export default function Point(args) {
  this.x = args.x
  this.y = args.y
  this.z = args.z
  this.a = args.a
  this.h = args.h
}
